<template>
  <FormSection title="Meilensteine">
    <template #text>
      Was sind deine nächsten Meilensteine? Bestimme die Zielwerte für deinen Podcast.
    </template>
    <template #form>
      <MilestonesForm :resource="resource" :errors="errors" :metrics="metrics"/>
    </template>
  </FormSection>
  <FormButtons>
    <div class="space-x-2">
      <BackButton />
      <SubmitButton @click="onSubmit" :load="creating">
        Aktualisieren
      </SubmitButton>
    </div>
  </FormButtons>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { useCreateResource } from '@/client/actions';

const store = useStore();
const router = useRouter();

const context = computed(() => store.getters['context/context']);
const parent = computed(() => context.value.id);
const metrics = computed(() => context.value.traceable ?? []);
const values = computed(() => context.value.milestones ?? {});
const target = computed(() => '/api/podcasts/' + parent.value + '/milestones:batch');
const action = useCreateResource(target, {...values.value}, false);

const { resource, errors, message, create, creating } = action;

const onSuccess = () => store.dispatch('context/setup');
const onSubmit = () => create(onSuccess);
</script>
